import React from 'react';
import { User } from 'lucide-react';

const ProfilePicture = ({ 
  src, 
  alt = "Profile", 
  size = "md", 
  className = "",
  showBorder = true 
}) => {
  const sizeClasses = {
    xs: "w-8 h-8",
    sm: "w-12 h-12", 
    md: "w-16 h-16",
    lg: "w-20 h-20",
    xl: "w-24 h-24",
    "2xl": "w-32 h-32"
  };

  const iconSizes = {
    xs: 16,
    sm: 20,
    md: 24,
    lg: 28,
    xl: 32,
    "2xl": 40
  };

  const borderClass = showBorder ? "border-4 border-purple-300" : "";

  return (
    <div className={`${sizeClasses[size]} ${borderClass} rounded-full overflow-hidden ${className}`}>
      {src ? (
        <img 
          src={src} 
          alt={alt} 
          className="w-full h-full object-cover"
        />
      ) : (
        <div className="w-full h-full bg-gradient-to-br from-purple-400 to-pink-400 flex items-center justify-center">
          <User className="text-white" size={iconSizes[size]} />
        </div>
      )}
    </div>
  );
};

export default ProfilePicture;
